import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface CollapsibleContentComponentProps {
  node: any;
  updateAttributes: (attributes: Record<string, any>) => void;
  selected: boolean;
}

const CollapsibleContentComponent: React.FC<CollapsibleContentComponentProps> = ({
  node,
  updateAttributes,
  selected,
}) => {
  const theme = useTheme();
  const { isCollapsed } = node.attrs;

  const toggleCollapse = () => {
    updateAttributes({ isCollapsed: !isCollapsed });
  };

  if (isCollapsed) {
    return (
      <NodeViewWrapper className="collapsible-content-wrapper">
        <Box
          onClick={toggleCollapse}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '2px 0',
            margin: '8px 0',
            width: '24px',
            height: '12px',
            backgroundColor: '#f0f0f0',
            border: '1px solid #d0d0d0',
            fontSize: '14px',
            fontFamily: 'arial, sans-serif',
            fontWeight: 'bold',
            color: '#333',
            userSelect: 'none',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#e8e8e8',
              borderColor: '#c0c0c0',
            },
            ...(selected && {
              outline: `1px solid ${theme.palette.primary.main}`,
            }),
          }}
        >
          ⋯
        </Box>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper className="collapsible-content-wrapper">
      <Box
        sx={{
          margin: '0',
          position: 'relative',
          ...(selected && {
            outline: `1px solid ${theme.palette.primary.main}`,
          }),
        }}
      >
        {/* Gmail-style quoted content */}
        <Box
          sx={{
            borderLeft: '3px solid #cccccc',
            paddingLeft: '10px',
            margin: '0',
            color: '#777777',
            fontSize: '13px',
            fontFamily: 'arial, sans-serif',
            lineHeight: '1.4',
            '& strong': {
              fontWeight: 'bold',
              color: '#333333',
            },
            '& div': {
              margin: '0 0 2px 0',
              lineHeight: '1.4',
              fontSize: '13px',
            },
            '& p': {
              margin: '0 0 2px 0',
              lineHeight: '1.4',
              fontSize: '13px',
              '&:last-child': {
                marginBottom: 0,
              },
            },
          }}
        >
          {/* Click-to-collapse dots - positioned at the top right */}
          <Box
            onClick={toggleCollapse}
            sx={{
              position: 'absolute',
              right: '0px',
              top: '0px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '20px',
              height: '10px',
              backgroundColor: '#f0f0f0',
              border: '1px solid #d0d0d0',
              fontSize: '12px',
              fontFamily: 'arial, sans-serif',
              fontWeight: 'bold',
              color: '#333',
              zIndex: 1,
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#e8e8e8',
                borderColor: '#c0c0c0',
              },
            }}
          >
            ⋯
          </Box>
          
          <NodeViewContent />
        </Box>
      </Box>
    </NodeViewWrapper>
  );
};

export default CollapsibleContentComponent;
